import axios from "axios";
import { z } from "zod";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
import { ParameterValues } from "../Types";
import { searchParametersUrl } from "./urls";
export const SearchParameterFieldType = z.lazy(() => z.object({
    type: z.string(),
    kinds: z.union([z.array(z.string()), z.string()]).optional(),
    value: z.unknown().optional(),
    params: z
        .record(z.string(), z.union([
        z.string(),
        z.number(),
        z.boolean(),
        z.null(),
        z.array(z.unknown()),
        SearchParameterFieldType,
        z.record(z.string(), z.unknown()),
    ]))
        .optional(),
}));
export const SearchParametersRequest = z.object({
    meta: z.unknown().nullable().optional(),
    fields: z.record(z.string(), SearchParameterFieldType),
});
export const SearchParametersResponse = z.object({
    data: z.record(z.string(), ParameterValues),
});
export default async function searchParameters(request, config) {
    const { data } = await axios.post(searchParametersUrl("v4"), request, {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Advisor: config.advisorId,
        },
    });
    const decoded = SearchParametersResponse.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "[searchParameters] returned unexpected data.";
        errorLog(searchParameters.name, JSON.stringify(decoded.error.issues));
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=searchParameters.js.map